var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7167 -0.000162125C20.8667 -0.000162125 20.0833 0.483171 19.7167 1.23317L17.35 5.9665C17.1167 6.43317 17 6.93317 17 7.44984V14.9998C17 15.9165 17.75 16.6665 18.6667 16.6665H25.3333C26.25 16.6665 27 15.9165 27 14.9998V8.33317C27 7.4165 26.25 6.6665 25.3333 6.6665H22L23.7167 3.23317C24.4667 1.74984 23.3833 -0.000162125 21.7167 -0.000162125ZM5.05 -0.000162125C4.2 -0.000162125 3.41667 0.483171 3.05 1.23317L0.683334 5.9665C0.450001 6.43317 0.333336 6.93317 0.333336 7.44984V14.9998C0.333336 15.9165 1.08334 16.6665 2 16.6665H8.66667C9.58334 16.6665 10.3333 15.9165 10.3333 14.9998V8.33317C10.3333 7.4165 9.58334 6.6665 8.66667 6.6665H5.33334L7.05 3.23317C7.8 1.74984 6.71667 -0.000162125 5.05 -0.000162125Z",
    fill: "#82B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenQuotes);
export default __webpack_public_path__ + "static/media/open-quotes.79c812977dfef1421241a6850d61e64c.svg";
export { ForwardRef as ReactComponent };